<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Lista Global de Requerimientos">
          <div class="form-group form-inline pull-left">
            <select v-model="numPages" class="form-control">
              <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
            </select>&nbsp;
            <input v-model="search" type="search" class="form-control" placeholder="Buscar" />
          </div>
          <div class="form-group form-inline pull-right">
            <date-picker
              v-model="date.start"
              lang="es"
              type="date"
              placeholder="Desde"
              required
              format="DD/MM/YYYY"
            ></date-picker>&nbsp;
            <date-picker
              v-model="date.end"
              lang="es"
              type="date"
              placeholder="Hasta"
              required
              format="DD/MM/YYYY"
            ></date-picker>&nbsp;
            <button class="btn btn-primary" @click="getRqs()">Buscar</button>&nbsp;
            <download-excel
              class="btn btn-primary"
              :data="filteredRqs"
              :fields="json_fields"
              name="Finalizados.xls"
            >Descargar Excel</download-excel>
          </div>
          <div class="table-responsive rqTable">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>
                    <a href="javscript:void(0)" @click="sort('id')">
                      #RQ
                      <i
                        v-if="currentSort === 'id'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('service.doc_number')">
                      BL/Booking
                      <i
                        v-if="currentSort === 'service.doc_number'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('service.service_type.name')">
                      Servicio
                      <i
                        v-if="currentSort === 'service.service_type.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>Servicio Indirecto</th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('date')">
                      Fecha
                      <i
                        v-if="currentSort === 'date'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('service.company.name')">
                      Cliente
                      <i
                        v-if="currentSort === 'service.company.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('service.company.company_bill.name')">
                      Facturar a
                      <i
                        v-if="currentSort === 'service.company.company_bill.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('address.alias')">
                      Dirección/Zona
                      <i
                        v-if="currentSort === 'address.alias'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('deposit_pick.name')">
                      Depósito de retiro
                      <i
                        v-if="currentSort === 'deposit_pick.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('deposit.name')">
                      Depósito de devolución (impo) o de entrega Full (expo)
                      <i
                        v-if="currentSort === 'deposit.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('truck.plate')">
                      Placa
                      <i
                        v-if="currentSort === 'truck.plate'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('truck.provider.name')">
                      Transporte
                      <i
                        v-if="currentSort === 'truck.provider.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('driver.name')">
                      Conductor
                      <i
                        v-if="currentSort === 'driver.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('container_number')">
                      Contenedor
                      <i
                        v-if="currentSort === 'container_number'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>
                  </th>
                  <th>Tamaño</th>
                  <th>Tipo de carga</th>
                  <th>Resguardo</th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('seal_line')">
                      Precinto de linea 
                      <i 
                        v-if="currentSort === 'seal_line'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('seal_customs')">
                      Precinto de aduana 
                      <i 
                        v-if="currentSort === 'seal_customs'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('seal_tare')">
                      Tara
                      <i 
                        v-if="currentSort === 'seal_tare'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>Solicitante</th>
                  <th>Creado el</th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('status.name')">
                      Estado
                      <i 
                        v-if="currentSort === 'status.name'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('production_sheet')">
                      Hoja de producción
                      <i 
                        v-if="currentSort === 'production_sheet'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>
                    <a href="javscript:void(0)" @click="sort('number_eir')">
                      Número EIR (impo)
                      <i 
                        v-if="currentSort === 'number_eir'"
                        :class="`fa fa-sort-${currentSortDir === 'asc'? 'up' : 'down'}`"
                      ></i>
                    </a>  
                  </th>
                  <th>Documentos</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rq,k) in paginated('filteredRqs')"
                  :key="k"
                  @contextmenu.prevent="selectRq(rq)"
                >
                  <td>
                    <span
                      v-if="!rq.number_eir && constants.DEVOLUCIONES === rq.service.service_type.code"
                      class="badge badge-pill badge-danger"
                    >EIR</span>
                    {{rq.id}}
                  </td>
                  <td>{{rq.service.doc_number}}</td>
                  <td>{{rq.service.service_type.name}}</td>
                  <td>{{ (rq.status_logs.length && rq.status_logs[0].status.id) || (rq.service.requeriment_id) ? ' SI' : '--'}}</td>
                  <td>{{rq.date | formatDateTime}}</td>
                  <td>{{rq.service.company ? rq.service.company.name : ''}}</td>
                  <td>{{rq.service.company ? (rq.service.company.company_bill.name || '') : ''}}</td>
                  <td>{{rq.address? `${rq.address.alias} - ${rq.address.place.name}` : ''}}</td>
                  <td>{{rq.deposit_pick ? rq.deposit_pick.name : ''}}</td>
                  <td>{{rq.deposit ? rq.deposit.name : ''}}</td>
                  <td>{{rq.truck ? rq.truck.plate : ''}}</td>
                  <td>{{rq.truck ? rq.truck.provider.name : ''}}</td>
                  <td>{{rq.driver ? `${rq.driver.name} ${rq.driver.last_name}` : '' }}</td>
                  <td>{{rq.container_number}}</td>
                  <td>{{rq.container_size ? rq.container_size.name : ''}}</td>
                  <td>{{rq.charge_type ? rq.charge_type.name : ''}}</td>
                  <td>{{rq.guard ? (rq.custody ? rq.custody.name : 'Si, custodia no indicada') : 'No'}}</td>
                  <td>{{rq.seal_line}}</td>
                  <td>{{rq.seal_customs}}</td>
                  <td>{{rq.seal_tare}}</td>
                  <td>
                    {{
                      rq.service.applicant
                        ? `${rq.service.applicant.name} ${rq.service.applicant.last_name}`
                        : ""
                    }}
                  </td>
                  <td>{{ rq.created_at | formatDateTime }}</td>
                  <td>{{rq.status.name}}</td>
                  <td>{{rq.production_sheet ? rq.production_sheet : '--'}}</td>
                  <td>{{rq.number_eir ? rq.number_eir : '--'}}</td>
                  <td width="200">
                    <button
                      @click="openModalEir(rq.doc_eir)"
                      type="button"
                      class="btn btn-primary btn-sm"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      v-if="rq.doc_eir"
                      style="margin-bottom: 5px;"
                    >
                      <i class="fa fa-file"></i> EIR
                    </button>
                    <button
                      v-if="[constants.DEVOLUCIONES, constants.IMPORTACION].includes(rq.service.service_type.code)"
                      @click="openModalAddEir(rq)"
                      type="button"
                      class="btn btn-primary btn-sm"
                      style="margin-bottom: 5px;"
                    >
                      <i class="fa fa-file"></i> {{rq.doc_eir ? 'Editar':'Agregar'}} EIR
                    </button>
                    <button
                      @click="openModalDoc('Ticket de balanza', 'doc_scales',rq.scales_ticket)"
                      type="button"
                      class="btn btn-primary"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      v-if="rq.scales_ticket"
                      style="margin-bottom: 5px;"
                    >
                      <i class="fa fa-file"></i> Ticket balanza
                    </button>
                    <button
                      @click="openModalDoc('Guía de remisión cliente', 'doc_guide',rq.client_guide)"
                      type="button"
                      class="btn btn-primary"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      v-if="rq.client_guide"
                      style="margin-bottom: 5px;"
                    >
                      <i class="fa fa-file"></i> Guia cliente
                    </button>
                    <button
                      @click="openModalDoc('Guía de remisión transportista', 'doc_guide',rq.transport_guide)"
                      type="button"
                      class="btn btn-primary"
                      data-toggle="modal"
                      data-target="#exampleModal"
                      v-if="rq.transport_guide"
                    >
                      <i class="fa fa-file"></i> Guia transportista
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <ModalEIR :showModalEir="showModalEir" :doc_eir="doc_eir" @close="closeModal()" />
            <ModalAddEIR :showModal="showModalAddEir" :rq="rq" @close="closeModal()" />
            <ModalDoc
              :showModalDoc="showModalDoc"
              :document="document"
              :document_name="document_name"
              @close="closeModal()"
            />
            <div
              v-if="showModalEir || showModalDoc || showModalAddEir"
              class="modal-backdrop fade show"
            ></div>

            <paginate name="filteredRqs" :list="filteredRqs" class="paginate-list" :per="numPages"></paginate>
            <paginate-links
              for="filteredRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>
            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import s3 from "@/helpers/aws";
import constants from "@/constants";
import ModalEIR from "@/views/client/services/ModalEir";
import ModalAddEIR from "./ModalAddEir";
import ModalDoc from "./ModalDoc";
import _ from "lodash";
import moment from "moment";
export default {
  components: { ModalEIR, ModalDoc, ModalAddEIR },
  data() {
    return {
      rqs: [],
      rq: {},
      paginate: ["filteredRqs"],
      search: "",
      numPages: 100,
      date: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59:59")
      },
      showModalEir: false,
      showModalDoc: false,
      showModalAddEir: false,
      doc_eir: "",
      document: "",
      document_name: "",
      json_fields: {
        "#RQ": "id",
        "BL/Booking": "service.doc_number",
        Servicio: "service.service_type.name",
        'Servicio Indirecto': {
          callback: (rq) => {
            return (rq.status_logs.length && rq.status_logs[0].status.id) || (rq.service.requeriment_id) ? ' SI' : ''
          }
        },
        "Fecha (cita)": {
          field: "date",
          callback: value => {
            return moment(value).format("DD/MM/YYYY HH:mm");
          }
        },
        Cliente: "service.company.name",
        "Facturar a": {
          field: "service.company",
          callback: company => {
            return company ? company.company_bill.name : "";
          }
        },
        Direccion: {
          field: "address.alias",
          callback: value => {
            return value ? value : "";
          }
        },
        "Depósito de retiro": {
          field: "deposit_pick",
          callback: deposit_pick => {
            return deposit_pick ? deposit_pick.name : "";
          }
        },
        "Depósito de devolución (impo) o entrega Full (expo)": {
          field: "deposit",
          callback: deposit => {
            return deposit ? deposit.name : "";
          }
        },
        Zona: "address.place.name",
        Placa: {
          field: "truck",
          callback: truck => {
            return truck ? truck.plate : "";
          }
        },
        Transporte: {
          field: "truck",
          callback: truck => {
            return truck ? truck.provider.name : "";
          }
        },
        Celular: {
          field: "truck",
          callback: truck => {
            return truck ? truck.mobile : "";
          }
        },
        Conductor: {
          field: "driver",
          callback: driver => {
            return driver ? `${driver.name} ${driver.last_name}` : "";
          }
        },
        Contenedor: "container_number",
        "Tamaño": "container_size.name",
        "Tipo de carga": "charge_type.name",
        "Resguardo": {
          callback: rq => {
            return rq.guard ? (rq.custody ? rq.custody.name : 'Si, custodia no indicada') : 'No'
          }
        },
        "Precinto de Linea": "seal_line",
        "Precinto de Aduana": "seal_customs",
        Tara: "seal_tare",
        Solicitante: {
          field: "service",
          callback: (service) => {
            return service.applicant
              ? `${service.applicant.name} ${service.applicant.last_name}`
              : "";
          },
        },
        "Creado el": {
          field: "created_at",
          callback: (value) => {
            return value ? moment(value).format("DD/MM/YYYY HH:mm") : "";
          },
        },
        Estado: "status.name",
        "Hoja de produccion": "production_sheet",
        EIR: "number_eir"
      },
      currentSort: "id",
      currentSortDir: "asc"
    };
  },
  computed: {
    filteredRqs() {
      const searchWord = this.search.toLowerCase();
      return this.rqs.filter(rq => {
        let condition = true;
        if (this.search) {
          const companyCondition = rq.service.company
            ? this.searchCondition(rq.service.company.name)
            : false;
          const companyBillCondition = rq.service.company
            ? this.searchCondition(rq.service.company.company_bill.name)
            : false;
          const truckCondition = rq.truck
            ? this.searchCondition(rq.truck.plate)
            : false;
          const docCondition = this.searchCondition(rq.service.doc_number);
          const containerCondition = this.searchCondition(rq.container_number);
          const providerCondition =
            rq.truck && rq.truck.provider
              ? this.searchCondition(rq.truck.provider.name)
              : false;
          const chargeTypeCondition = rq.charge_type
            ? this.searchCondition(rq.charge_type.name)
            : false;
          const addressCondition = rq.address
            ? this.searchCondition(`${rq.address.alias}`)
            : false;
          const depositPickCondition = rq.deposit_pick
            ? this.searchCondition(rq.deposit_pick.name)
            : false;
          const depositCondition = rq.deposit
            ? this.searchCondition(rq.deposit.name)
            : false;
          const driverCondition = rq.driver
            ? this.searchCondition(`${rq.driver.name} ${rq.driver.last_name}`)
            : false;
          const guardCondition =
            rq.guard && rq.custody
              ? this.searchCondition(rq.custody.name)
              : false;
          const serviceTypeCondition = rq.service.service_type
            ? this.searchCondition(rq.service.service_type.name)
            : false;

          condition =
            condition &&
            (companyCondition ||
              companyBillCondition ||
              truckCondition ||
              docCondition ||
              addressCondition ||
              depositPickCondition ||
              depositCondition ||
              providerCondition ||
              containerCondition ||
              driverCondition ||
              guardCondition ||
              chargeTypeCondition ||
              serviceTypeCondition ||
              searchWord === rq.id.toString());
        }
        return condition;
      }).sort((objA, objB) => {
        let modifier = 1;
        if (this.currentSortDir === "desc") modifier = -1;
        let a = _.get(objA, this.currentSort);
        let b = _.get(objB, this.currentSort);
        if (!a) a = "";
        if (!b) b = "";
        if (a < b) return -1 * modifier;
        if (a > b) return 1 * modifier;
        return 0;
      });
    }
  },
  mounted() {
    this.constants = constants;
    this.getRqs();
  },
  methods: {
    onFileChange(e, rq) {
      var files = e.target.files || e.dataTransfer.files;
      const permitted_ext = ["image/png", "image/jpeg", "image/jpg"];
      if (!files.length || !permitted_ext.includes(files[0].type)) {
        this.showError("Formato de archivo inválido.");
      } else {
        const formData = new FormData();
        formData.append("doc_eir", files[0]);
        formData.append("requeriment_id", rq.id.toString());
        formData.append("number_eir", eir.toString());
        api.post(`/eir`, formData).then(response => {});
      }
    },
    searchCondition(field) {
      const searchWord = this.search.toLowerCase();
      return (field || "").toLowerCase().includes(searchWord);
    },
    getRqs() {
      const data = {
        service_code: null,
        finish: true,
        assigned: false,
        date_start: moment(this.date.start).format("YYYY-MM-DD 00:00"),
        date_end: moment(this.date.end).format("YYYY-MM-DD 23:59")
      };
      api.post("list_requeriments", data).then(response => {
        this.rqs = response.requeriments;
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      let link = this.rq.service.service_type.url;
      let url = `/${
        this.rq.service.service_type.void ? "voids" : "requeriments"
      }/${link}/detail/${this.rq.id}`;
      this.$router.push(url);
    },
    closeModal() {
      this.showModalEir = false;
      this.showModalDoc = false;
      this.showModalAddEir = false;
      this.doc_eir = "";
      this.document = "";
      this.document_name = "";
    },
    openModalEir(doc_eir) {
      const url = s3.getSignedUrl("getObject", {
        Bucket: `${process.env.VUE_APP_AWS_BUCKET}/doc_eir`,
        Key: doc_eir,
        Expires: 60
      });
      this.doc_eir = url;
      this.showModalEir = true;
    },
    openModalAddEir(rq) {
      console.log("ABRE", rq);
      this.rq = rq;
      this.showModalAddEir = true;
    },
    openModalDoc(name, folder, doc) {
      const url = s3.getSignedUrl("getObject", {
        Bucket: `${process.env.VUE_APP_AWS_BUCKET}/${folder}`,
        Key: doc,
        Expires: 60
      });

      this.document = url; //`${folder}/${doc}`;
      this.document_name = name;
      this.showModalDoc = true;
    },
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      }
      this.currentSort = s;
    }
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateRequeriment: function(rq) {
      let index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0) {
        this.rqs.splice(index, 1, rq);
      }
    }
  }
};
</script>
<style scoped>
  th a {
    color: #000 !important;
  }
</style>
